<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p13
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p13" title="mthfr-p13">
    <img-card>
      <div>{{$t('Mthfr.P13_Title')}}</div>
      <ul>
        <li>{{$t('Mthfr.P13_1')}}</li>
        <li>{{$t('Mthfr.P13_2')}}</li>
        <li>{{$t('Mthfr.P13_3')}}</li>
        <li>{{$t('Mthfr.P13_4')}}</li>
        <li>{{$t('Mthfr.P13_5')}}</li>
        <li>{{$t('Mthfr.P13_6')}}</li>
        <li>{{$t('Mthfr.P13_7')}}</li>
        <li>{{$t('Mthfr.P13_8')}}</li>
        <li>{{$t('Mthfr.P13_9')}}</li>
        <li>{{$t('Mthfr.P13_10')}}</li>
        <li>{{$t('Mthfr.P13_11')}}</li>
        <li>{{$t('Mthfr.P13_12')}}</li>
      </ul>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p13",
    components: {ImgCard}
  }
</script>

<style lang="scss">
  .v-mthfr-p13 {
    margin-bottom: 30px;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: 12px;
      line-height: 29.75px;
      letter-spacing: 0.3px;
      color: #000000;
    }

    .v-card-title {
      display: none;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p13.vue